import React, { useEffect, useState } from "react";
import { Navbar, Footer } from "../hrcomponents";
import axios from "axios";
import configData from "../config.json";
import * as Icon from "react-bootstrap-icons";
import { monthList } from "../utils/datalist";

const AttenRegister = () => {
  if (localStorage.getItem("branchID") === null) {
    window.location.replace("/hris");
  }

  const [attenData, setSearchData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [aYear, setYear] = useState(new Date().getFullYear());
  const [aMonth, setMonthName] = useState(new Date().getMonth() + 1);
  const [departments, setDepartment] = useState([]);
  const [noResults, setNoResults] = useState(false);

  const daysInMonth = new Date(aYear, aMonth, 0).getDate();

  useEffect(() => {
    const getDepartment = async () => {
      try {
        const response = await axios.get(
          configData.SERVER_URL +
            `/departments/${localStorage.getItem("branchID")}`
        );

        setDepartment(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getDepartment();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get(
        configData.SERVER_URL +
          `/attnRegister/${aYear}/${aMonth}/${localStorage.getItem(
            "branchID"
          )}`
      );

      setSearchData(res.data);
      setFilter(res.data);

      setNoResults(res.data.length === 0);
    } catch (error) {
      console.error("Search error:", error);
    }
  };

  const filterData = (e) => {
    const deptId = Number(e.target.value);

    if (deptId === 0) {
      setFilter(attenData);
    } else {
      const updatedList = attenData.filter(
        (fData) => fData.deptID === deptId
      );

      setFilter(updatedList);
    }
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "P":
        return {
          backgroundColor: "#d1e7dd",
          color: "#0f5132",
          fontWeight: "bold",
        };

      case "A":
        return {
          backgroundColor: "#f8d7da",
          color: "#842029",
          fontWeight: "bold",
        };

      case "L":
        return {
          backgroundColor: "#fff3cd",
          color: "#664d03",
          fontWeight: "bold",
        };

      default:
        return {};
    }
  };

  const printDiv = (printDiv) => {

    const printElement = document.getElementById(printDiv);

        if (!printElement) {
            console.error("Print div not found");
            return;
        }

        const printWindow = window.open("", "_blank", "width=900,height=650");

        printWindow.document.write(`
            <html>
                <head>
                <title>Print</title>
                <!-- Bootstrap CSS (optional) -->
                <link rel="stylesheet"  href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"/>
                <style>
                    body{ padding:20px; font-family: Arial, sans-serif;}
                    @media print { body{ margin:0; }}
                </style>
                </head>
                <body>
                    ${printElement.innerHTML}
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

  return (
    <>
      <div
        className="container-fluid">

        {/* Top Card */}
        <div
          className="card shadow-lg border-0 mb-4"
          style={{
            borderRadius: "18px",
            overflow: "hidden",
          }}
        >
          {/* Header */}
          <div
            className="card-header"
            style={{
              background:
                "linear-gradient(135deg, #0d6efd, #0dcaf0)",
              padding: "20px",
              color: "#fff",
            }}
          >
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="fw-bold mb-1">
                  Attendance Register
                </h3>

                <small>
                  Monthly employee attendance report
                </small>
              </div>

              <div
                className="px-3 py-2"
                style={{
                  backgroundColor: "rgba(255,255,255,0.2)",
                  borderRadius: "10px",
                }}
              >
                Total Employee: {filter?.length || 0}
              </div>

              <button  type="button" className="btn btn-light"
                    onClick={()=>printDiv("printDiv_Attn")}
                    style={{ borderRadius: "50px", padding: "10px 18px", fontWeight: "600",}}
                  >
                    <Icon.Printer className="me-2" />
                    Print
                  </button>
            </div>
          </div>

          {/* Filter Section */}
          <div
            className="card-body"
            style={{
              backgroundColor: "#f8f9fa",
            }}
          >
            <div className="row g-3 align-items-end">
              {/* Month */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold">
                  Month
                </label>

                <select
                  className="form-select shadow-sm"
                  id="monthName"
                  name="monthName"
                  value={aMonth}
                  onChange={(e) =>
                    setMonthName(e.target.value)
                  }
                  style={{ borderRadius: "10px" }}
                >
                  {monthList.map((month) => (
                    <option
                      key={month.id}
                      value={month.id}
                    >
                      {month.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Year */}
              <div className="col-lg-2 col-md-4">
                <label className="form-label fw-semibold"> Year</label>

                <input type="number" className="form-control shadow-sm" value={aYear}
                  onChange={(e) =>setYear(e.target.value) } 
                  style={{ borderRadius: "10px" }}
                />
              </div>

              {/* Search Button */}
              <div className="col-lg-2 col-md-4">
                <button
                  type="button"
                  className="btn btn-primary w-100 shadow-sm"
                  onClick={handleSubmit}
                  style={{
                    borderRadius: "10px",
                    height: "42px",
                    fontWeight: "600",
                  }}
                >
                  <Icon.Search className="me-2" />
                  Search
                </button>
              </div>

              {/* Department */}
              <div className="col-lg-3 col-md-6">
                <label className="form-label fw-semibold">
                  <Icon.Filter className="me-1" />
                  Department
                </label>

                <select
                  className="form-select shadow-sm"
                  onChange={filterData}
                  style={{ borderRadius: "10px" }}
                >
                  <option value={0}>--- ALL ---</option>

                  {departments.map((dept) => (
                    <option
                      key={dept.id}
                      value={dept.id}
                    >
                      {dept.deptName}
                    </option>
                  ))}
                </select>
              </div>

              {/* Days */}
              <div className="col-lg-3 col-md-6">
                <div
                  className="p-3 text-center shadow-sm"
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    fontWeight: "bold",
                    color: "#0d6efd",
                  }}
                >
                  Days In Month : {daysInMonth}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div
          className="card border-0 shadow-lg"
          style={{
            borderRadius: "18px",
          }}
          id="printDiv_Attn"
        >
          <div
            className="card-header d-flex justify-content-between align-items-center"
            style={{
              backgroundColor: "#198754",
              color: "#fff",
            }}
          >
            <h5 className="mb-0 fw-bold">
              Attendance Details for the month of ({aMonth},{aYear})
            </h5>

            <span className="badge bg-light text-dark px-3 py-2">
              Records : {filter?.length || 0}
            </span>
          </div>

          {/* No Data */}
          {noResults && (
            <div className="alert alert-warning text-center m-3">
              No results found.
            </div>
          )}

          {/* Table */}
          <div
            className="card-body table-responsive"
            style={{
              backgroundColor: "#fff",
            }}
          >
            <table
              className="table table-hover table-bordered align-middle"
              style={{
                fontSize: "12px",
                whiteSpace: "nowrap",
              }}
            >
              <thead
                className="text-center"
                style={{
                  backgroundColor: "#198754",
                  color: "#fff",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                }}
              >
                <tr>
                  {/* <th>Month</th>
                  <th>Year</th> */}
                  {/* <th>Department</th>
                  <th>Emp Code</th>
                  <th>Employee</th> */}

                  {Array.from(
                    { length: 31 },
                    (_, i) => (
                      <th key={i}>
                        D-{i + 1}
                      </th>
                    )
                  )}

                  <th className="bg-success">T-P</th>
                  <th className="bg-primary">T-La</th>
                  <th className="bg-warning text-dark">T-L</th>
                  <th className="bg-danger">T-A</th>
                </tr>
              </thead>

              <tbody>
                {filter &&
                  filter.length > 0 &&
                  filter.map((data, index) => (
                    <>
                    <tr><td colSpan={35}>{data.deptName},{data.empCode},{data.empName}</td></tr>
                    <tr key={index}>
                      {/* <td>{data.month_name}</td>
                      <td>{data.aYear}</td> */}
                      {/* <td className="fw-semibold">
                        {data.deptName}
                      </td>
                      <td>{data.empCode}</td>
                      <td className="fw-semibold">
                        {data.empName}
                      </td> */}
               

                      {Array.from(
                        { length: 31 },
                        (_, i) => {
                          const value =
                            data[`d${i + 1}`];

                          return (
                            <td
                              key={i}
                              className="text-center" style={getStatusStyle(value)}
                            >
                              {value}
                            </td>
                          );
                        }
                      )}

                      <td className="text-success fw-bold">
                        {data.total_present}
                      </td>

                      <td className="text-primary fw-bold">
                        {data.total_late}
                      </td>

                      <td className="text-warning fw-bold">
                        {data.total_leave}
                      </td>

                      <td className="text-danger fw-bold">
                        {data.total_absent}
                      </td>
                    </tr>
                    </>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </>
  );
};

export default AttenRegister;